module.exports = __webpack_public_path__ + "img/344.04043508.png";